module.exports = __webpack_public_path__ + "img/draw_bonus4.76ee2298.png";